import React, { useState } from 'react';
import { NavLink,Link } from 'react-router-dom';
import {FaBars, FaTimes} from 'react-icons/fa';

function Navbar(){

    const handleSmoothScroll = (e, targetId) => {
        e.preventDefault();
        const targetElement = document.querySelector(targetId);
        window.scrollTo({
          top: targetElement.offsetTop - 100,
          behavior: 'smooth',
        });
    }

    const [menuOpen, setMenuOpen] = useState(false);

    return(
            <nav className = "nav">
                <Link to = "/" className = "siteTitle">Liam Mazure</Link>

                <ul className ={menuOpen ? "open" : ""} >
                    <li>
                        <div className='dropDown'>
                            <NavLink id = "project_link" className = "nav_link" to = "/projects">Projects</NavLink>
                            <div className='dropDown_menu'>
                                <NavLink to = "/projects" className='dropDown_link' onClick={(e) => handleSmoothScroll(e, '.sec-1')}>Augmented Reality(AR)</NavLink>
                                <NavLink to = "/projects" className='dropDown_link' onClick={(e) => handleSmoothScroll(e, '.sec-2')}>Website Development</NavLink>
                                <NavLink to = "/projects" className='dropDown_link' onClick={(e) => handleSmoothScroll(e, '.sec-3')}>Video Games</NavLink>
                                <NavLink to = "/projects" className='dropDown_link' onClick={(e) => handleSmoothScroll(e, '.sec-4')}>Mobile Applications</NavLink>
                                <NavLink to = "/projects" className='dropDown_link' onClick={(e) => handleSmoothScroll(e, '.sec-5')}>Data collection</NavLink>
                            </div>
                        </div>
                    </li>
                    <li>
                        <NavLink to = "/about"className='nav_link'>About Liam</NavLink>
                    </li>
                    <li>
                        <NavLink to = "/resume" className='nav_link'>Resume</NavLink>
                    </li>
                    <li>
                        <NavLink to = "/contact" className='nav_link'>Contact</NavLink>
                    </li>
                </ul>
                <button className={menuOpen ? 'nav_btn nav_hiddenBtn' : 'nav_btn nav_openBtn'} onClick={() => { setMenuOpen(!menuOpen)} }>
                    <FaBars/>
                </button>
                <button className={menuOpen ? 'nav_btn nav_activeBtn' : 'nav_btn nav_closeBtn'} onClick={() => { setMenuOpen(!menuOpen)}}>
                    <FaTimes/>
                </button>
            </nav>
    )
}

export default Navbar;